import { useMemo } from "react";
import { useCartStore } from "../store/useCartStore";
import { getCartCount, getCartTotal } from "../utils/cartCalculations";

export const useCart = () => {
    const cartItems = useCartStore((state) => state.items);
    const isCartOpen = useCartStore((state) => state.isOpen);

    const addToCart = useCartStore((state) => state.addToCart);
    const removeFromCart = useCartStore((state) => state.removeFromCart);
    const updateQuantity = useCartStore((state) => state.updateQuantity);
    const clearCart = useCartStore((state) => state.clearCart);
    const applyOperations = useCartStore((state) => state.applyOperations);
    const openCart = useCartStore((state) => state.openCart);
    const closeCart = useCartStore((state) => state.closeCart);
    const toggleCart = useCartStore((state) => state.toggleCart);

    const cartCount = useMemo(() => getCartCount(cartItems), [cartItems]);
    const cartTotal = useMemo(() => getCartTotal(cartItems), [cartItems]);

    return {
        cartItems,
        cartCount,
        cartTotal,
        isCartOpen,
        addToCart,
        removeFromCart,
        updateQuantity,
        clearCart,
        applyOperations,
        openCart,
        closeCart,
        toggleCart,
    };
};
